/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  base: "/rental/",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [

    // ===============================Hawk pages==============================================
    {
      path: "",
      component: () => import("@/layouts/hwakLayout/index.vue"),
      children: [
        {
          path: "/",
          name: "view",
          component: () => import("./views/booking/booking.vue"),
        },
      ],
    },
    {
      path: "",
      component: () => import("@/layouts/hwakLayout/withoutManageBooking.vue"),
      children: [
        {
          path: "/successBooking",
          name: "successBooking",
          component: () => import("./views/booking/thankyou.vue"),
        },
        {
          path: "/",
          name: "booking",
          component: () => import("./views/booking/booking.vue"),
        },
        {
          path: "/listing",
          name: "listing",
          component: () => import("./views/booking/listing.vue"),
        },
        {
          path: "/carDetails",
          name: "carDetails",
          component: () => import("./views/booking/carDetails.vue"),
        },
        {
          path: "/manageBooking",
          name: "manageBooking",
          component: () => import("./views/booking/manageBooking.vue"),
        },

        {
          path: "/testBooking",
          name: "testBooking",
          component: () => import("./views/booking/test.vue"),
        },

        {
          path: "/confirmation",
          name: "view",
          component: () => import("./views/booking/confirmation.vue"),
        },
        {
          path: "/payment",
          name: "payment",
          component: () => import("./views/booking/paymentV2.vue"),
        },
        {
          path: "/paymentv2",
          name: "paymentv2",
          component: () => import("./views/booking/paymentV2.vue"),
        },
      ],
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/",
    },
  ],
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
